import { mapMutations, mapGetters, mapActions } from "vuex";
import {
    SHOW_POPUP_AVAILABILITY_PROPS,
    SET_CURRENT_REQUISITE,
    SHOW_POPUP_BASKET,
    RESET_CUSTOM_BREADCRUMBS_LIST,
    CHANGE_POPUP_ADD_TO_FAVORITES,
    RESET_PRODUCT
} from "@/store/mutation-types";
import {
    GET_PRODUCT
} from "@/store/action-types";

const relatedProducts = () => import('./components/related-products/index.vue');
import gallery from './components/gallery-product/index.vue';
import CustomBreadcrumbs from '@/components/custom-breadcrumbs/index.vue';

export default {
    name: 'card',
    data(){
        return {
            params: {
                title: '',
                description: '',
                keywords: '',
                image: ''
            },
        }
    },
    head: {
        meta: function () {
            let meta = [
                { n: 'description', c: this.params.description, id: 'description' },
                { n: 'keywords', c: this.params.keywords, id: 'keywords' },
                { n: 'og:title', c: this.params.title, id: 'og:title' },
                { n: 'og:description', c: this.params.description, id: 'og:description' },
            ]

            if (Object.keys(this.$route.query).length > 0) {
                meta.push({ n: 'robots', c: 'noindex, nofollow' })
                return meta
            } else {
                return meta
            }
        },
        link: function () {
            let route = this.$route.path
            return [
                { rel: 'canonical', href: window.location.origin + this.$route.path, id: 'canonical' },
            ]
        }
    },
    components: {
        relatedProducts,
        gallery,
        CustomBreadcrumbs
    },
    computed: {
        ...mapGetters({
            product: 'card/product',
            productLoading: 'card/productLoading',
            breadcrumbsList: 'system/breadcrumbsList',
        }),
    },
    created(){
        this.fetchProduct({ slug: this.$route.params.item});
    },
    methods: {
        ...mapActions({
           fetchProduct: `card/${GET_PRODUCT}`
        }),
        ...mapMutations({
            changePopupCheck: `requisite/${SHOW_POPUP_AVAILABILITY_PROPS}`,
            setRequisite: `requisite/${SET_CURRENT_REQUISITE}`,
            changePopupBasket: `requisite/${SHOW_POPUP_BASKET}`,
            resetBreadcrumbs: `system/${RESET_CUSTOM_BREADCRUMBS_LIST}`,
            changePopupAddFavorites: `favorites/${CHANGE_POPUP_ADD_TO_FAVORITES}`,
            resetProduct: `card/${RESET_PRODUCT}`,
        }),
        setItemAndOpenPopupCheck(status, item){
            this.changePopupCheck(status);
            this.setRequisite(item);
        },
        setItemAndOpenPopupBasket(status, item){
            this.changePopupBasket(status);
            this.setRequisite(item);
        },
        setItemAndOpenPopupFavorites(status, item){
            this.changePopupAddFavorites(status);
            this.setRequisite(item);
        },
    },
    destroyed(){
        this.resetBreadcrumbs();
        this.resetProduct();
    }
}
